import { render, staticRenderFns } from "./FeedbackExplain.vue?vue&type=template&id=e8f97a0a&"
import script from "./FeedbackExplain.vue?vue&type=script&lang=js&"
export * from "./FeedbackExplain.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackExplain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FeedbackExplain.vue"
export default component.exports